import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { PortalDeterminationService } from '@core/services/portal-determination.service';
import { AuthBehaviors } from '@core/services/token/token-behaviors';
import { TokenService } from '@core/services/token/token.service';

export const initialRedirectResolver: ResolveFn<void> = (
  _: ActivatedRouteSnapshot,
  routerState: RouterStateSnapshot
) => {
  const { routeBase } = inject(PortalDeterminationService);
  if (routerState.url === `/${routeBase}`) {
    if (!inject(TokenService).hasCurrentValidToken()) {
      inject(Router).navigateByUrl(`/${routeBase}/auth/signin`);
    } else {
      inject(Router).navigateByUrl(inject(AuthBehaviors).current.postLoginRedirect);
    }
  }
};
